// extracted by mini-css-extract-plugin
export var currencyInput = "_oi-1";
export var currencySymbol = "_oi-0";